export default __webpack_public_path__ + "static/media/ms-word.baefbedd.svg";